module.exports = "/_next/static/images/2426e990fe83d37a9b5be6f0a0fd02c9-credit-card-limit@0.5x.png";